export * from './MinusSquareIcon';
export * from './MinusSquareIcon16Light';
export * from './MinusSquareIcon16Regular';
export * from './MinusSquareIcon16Solid';
export * from './MinusSquareIcon20Light';
export * from './MinusSquareIcon20Regular';
export * from './MinusSquareIcon20Solid';
export * from './MinusSquareIcon24Regular';
export * from './MinusSquareIcon24Solid';
export * from './MinusSquareIcon32Regular';
export * from './MinusSquareIcon64Regular';
